

// SlideToggle - Pop Up with button
$(document).ready(function(){

    $(".js-pop-up-toggle").click(function(){

        const $popupButton = $(this);
        const $popupSection = $(this).parent().siblings('.js-pop-up');
        
        $popupSection.slideToggle('slow', function() {
        if ($popupSection.css('display') !== 'none') {
          $popupButton.text('Close');
        }
        else {
          $popupButton.text('Open');
        }
      });
    });
  });